<template>
  <div>
    <div class="text" v-if="cardInfo.successContent">
      <span>{{ cardInfo.successContent }}</span>
    </div>
    <div
      class="ai-card"
      @mouseenter="isHovered = true"
      @mouseleave="isHovered = false"
      @click="cardClick"
    >
      <!-- 左侧 Logo -->
      <div class="card-logo">
        <img :src="logoUrl" alt="logo" />
      </div>

      <!-- 中间内容 -->
      <div class="card-content">
        <el-tooltip :content="cardInfo.title" placement="top" :disabled="true">
          <div class="card-title">
            {{ cardInfo.title }}
          </div>
        </el-tooltip>
        <div class="card-time">
          {{ cardInfo.subTitle }}
        </div>
      </div>

      <!-- 右侧下载图标 - 悬浮显示 -->
      <div
        class="card-download"
        v-show="isHovered"
        @click.stop="handleDownload"
        @mouseenter="isDownloadHovered = true"
        @mouseleave="isDownloadHovered = false"
      >
        <el-tooltip
          content="下载"
          placement="top"
          :disabled="!isDownloadHovered"
        >
          <img :src="downloadIconUrl" />
        </el-tooltip>
      </div>
    </div>
    <!-- 添加备注 -->
    <addremarks
      v-if="isShowRecordExport"
      ref="addremarks"
      :biFlag="false"
      :control="isShowRecordExport"
      @transData="(val) => (isShowRecordExport = val)"
      @transData1="exportTable"
    ></addremarks>
  </div>
</template>

<script>
import addremarks from "@/views/prefabricateReport/components/generate_report.vue";
import { exportAiAnalysis } from "@/api/ai/newAi.js";
export default {
  name: "AiCard",
  props: {
    // 卡片类型 - 用于展示不同的logo
    cardInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    addremarks,
  },
  data() {
    return {
      isHovered: false,
      isDownloadHovered: false,
      cdnUrl: "https://cdn-image.yucrm.cn/images/tb-front-platform/images/ai/",
      isShowRecordExport: false,
    };
  },
  computed: {
    type() {
      if (this.cardInfo.scenarioSubType == 1) {
        return "shop";
      } else if (this.cardInfo.scenarioSubType == 2) {
        return "sence";
      } else if (this.cardInfo.scenarioSubType == 3) {
        return "message";
      } else if (this.cardInfo.scenarioSubType == 4) {
        return "hd";
      }
    },
    jumpType() {
      if (["shop", "sence"].includes(this.type)) {
        return 3;
      } else {
        return 1;
      }
    },
    logoUrl() {
      // 根据类型返回不同的logo
      const logoMap = {
        shop: "ai-shop-fx.svg",
        sence: "ai-sence-fx.svg",
        hd: "ai-card-hd.svg",
        message: "ai-message-fx.svg",
      };
      return this.cdnUrl + (logoMap[this.type] || logoMap.shop);
    },
    downloadIconUrl() {
      return (
        this.cdnUrl +
        (this.isDownloadHovered
          ? "ai-card-download-hover.svg"
          : "ai-card-download.svg")
      );
    },
  },
  methods: {
    handleDownload() {
      this.isShowRecordExport = true;
    },
    cardClick() {
      this.$emit("cardClick", this.cardInfo);
    },
    exportTable(remark) {
      exportAiAnalysis({
        exportRemark: remark,
        msgId: this.cardInfo.chatId,
      }).then((res) => {
        if (res.code == 200) {
          this.$refs.addremarks.showSuccessDailog();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.text {
  padding-top: 8px;
  margin-bottom: 16px;
}
.ai-card {
  width: 312px;
  height: 80px;
  display: flex;
  align-items: center;
  padding: 16px 16px 16px 20px;
  background: #ffffff;
  border: 1px solid #e9e9e9;
  border-radius: 12px;
  cursor: pointer;
  margin-bottom: 8px;
  &:hover {
    box-shadow: 0px 4px 15px 0px rgba(225, 233, 252, 0.6);
  }

  /* Logo */
  .card-logo {
    width: 46px;
    height: 46px;
    margin-right: 12px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  /* 内容区域 */
  .card-content {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
  }

  .card-title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 1.5;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: max-width 0.2s ease;
  }

  .card-time {
    font-size: 12px;
    color: #999999;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    transition: max-width 0.2s ease;
  }

  /* 下载图标 */
  .card-download {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 16px;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
